import { useEffect, useRef, useState } from "react";

export default function useLivoraToast(duration = 2200) {
  const [toast, setToast] = useState({
    show: false,
    type: "success", // success | error | info
    message: "",
  });

  const timerRef = useRef(null);

  const showToast = (type, message) => {
    if (timerRef.current) clearTimeout(timerRef.current);

    setToast({
      show: true,
      type,
      message,
    });

    timerRef.current = setTimeout(() => {
      setToast({
        show: false,
        type: "success",
        message: "",
      });
    }, duration);
  };

  const hideToast = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({
      show: false,
      type: "success",
      message: "",
    });
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return {
    toast,
    showToast,
    hideToast,
  };
}